"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const Legend = (0, react_1.forwardRef)(({ children, className, error, screenReaderOnly, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("legend", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-legend', error && 'usa-label--error', screenReaderOnly && 'usa-sr-only', className), ...props, children: children }));
});
exports.default = Legend;
